/* 會員相關接口 */

import request from '@/utils/http/request'


export const _STATUS = {
    1: "啟用",
    0: "停用"
}

export const TRANSACTION_TYPE = {
    1: "儲值獲得",
    2: "活動消費",
    3: "場地消費",
    4: "轉讓",
    5: "退款返還",
    6: "儲值退款",
    7: "註冊獲得",
    8: "人工調整",
    9: "接收轉讓",
    10: "轉讓過期退還",
    11: "過期扣款"
}

export const ACCOUNT_TRANSACTION_TYPE = {
    1: "付費點數",
    2: "免費點數"
}

/* 會員列表 */
export async function fetchAll({ memberCode, name, phone, status, pageSize, pageNumber }) {
    return await request.get('/members', {
        params: {
            memberCode, name, phone, status, pageSize, pageNumber
        }
    });
}

/* 會員詳細資訊 */
export async function fetch(id) {
    return await request.get(`/members/${id}`);
}

/* 會員新增 */
export async function store({ name, phone, email, gender, status }) {
    return await request.post('/members', {
        name, phone, email, gender, status
    });
}

/* 會員資訊更新 */
export async function update({ id, name, phone, email, gender, status }) {
    return await request.put(`/members/${id}`, {
        name, phone, email, gender, status
    });
}

/* 會員狀態更新 */
export async function changeStatus({ id, status }) {
    return await request.put(`/members/changeStatus/${id}`, {
        status
    });
}

/* 會員刪除 */
// export async function members_del(id) {
//     return await request.delete(`/members/${id}`);
// }



/**
 * 點數記錄
 * @param {*} name 會員名稱
 * @param {*} orderId 訂單ID
 * @param {*} phone 手機號
 * @param {*} sDate 開始日期
 * @param {*} eDate 結束日期
 * @param {*} transactionType 消費類型: 1-儲值獲得 2-活動消費 3-場地消費 4-轉讓 5-退款返還 6-儲值退款 7-註冊獲得
 * @returns 
 */
export async function members_points({ name, orderId, phone, sDate, eDate, transactionType, pageNumber, pageSize }) {
    return await request.get(`/members/points`, {
        params: {
            name, orderId, phone, sDate, eDate, transactionType, pageNumber, pageSize
        }
    });
}

/**
 * 會員點數更新
 * @param {*} id 
 * @param {*} transactionType 動作狀態 1=增加/2=減少
 * @param {*} pointsAmount 
 * @param {*} transactionDesc 
 * @returns 
 */
export async function members_points_update({ id, transactionType, pointsAmount, transactionDesc }) {
    return await request.put(`/members/points`, {
        id, transactionType, pointsAmount, transactionDesc
    });
}

/* 轉點記錄列表 */
export async function members_points_transfer({ pageNumber, pageSize }) {
    return await request.get(`/members/points/transfer`, {
        params: {
            pageNumber, pageSize
        }
    });
}